exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-default-index-js": () => import("./../../../src/pages/default/index.js" /* webpackChunkName: "component---src-pages-default-index-js" */),
  "component---src-pages-socalyrg-com-photos-template-js": () => import("./../../../src/pages/socalyrg.com/photos_template.js" /* webpackChunkName: "component---src-pages-socalyrg-com-photos-template-js" */)
}

